import React, { useState } from 'react';
import axios from 'axios';
import API_URL from './config';

function Reports() {
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });

  const downloadReport = async (reportType, params = {}) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`${API_URL}/api/reports/${reportType}`, {
        params: { ...dateRange, ...params },
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${reportType}-${dateRange.startDate}-to-${dateRange.endDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      alert('Failed to download report');
    } finally {
      setLoading(false);
    }
  };

  const reports = [
    {
      id: 'allocation-summary',
      title: 'Allocation Summary',
      description: 'Complete list of all job allocations with details',
      icon: '📊',
      color: '#007AFF'
    },
    {
      id: 'asc-performance',
      title: 'ASC Performance',
      description: 'ASC-wise job allocation and email status',
      icon: '📈',
      color: '#34C759'
    },
    {
      id: 'unallocated',
      title: 'Unallocated Calls',
      description: 'List of calls that couldn\'t be allocated',
      icon: '❌',
      color: '#FF3B30'
    },
    {
      id: 'daily-trend',
      title: 'Daily Trend',
      description: 'Daily allocation trends with step breakdown',
      icon: '📅',
      color: '#FF9500'
    },
    {
      id: 'email-status',
      title: 'Email Status',
      description: 'Email delivery status for all allocations',
      icon: '✉️',
      color: '#AF52DE'
    }
  ];

  return (
    <div className="fade-in">
      <h1 className="page-title">Export Reports</h1>

      {/* Date Range Filter */}
      <div className="premium-card" style={{ marginBottom: '30px' }}>
        <h3>Filter by Date Range</h3>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginTop: '20px' }}>
          <input
            type="date"
            value={dateRange.startDate}
            onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
            className="premium-input"
            style={{ flex: 1 }}
          />
          <span style={{ color: 'var(--system-secondary-label)' }}>to</span>
          <input
            type="date"
            value={dateRange.endDate}
            onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
            className="premium-input"
            style={{ flex: 1 }}
          />
        </div>
      </div>

      {/* Reports Grid */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
        gap: '24px' 
      }}>
        {reports.map((report) => (
          <div key={report.id} className="premium-card report-card">
            <div 
              className="report-icon"
              style={{ 
                background: `linear-gradient(135deg, ${report.color}20 0%, ${report.color}10 100%)`,
                color: report.color
              }}
            >
              {report.icon}
            </div>
            
            <h3>{report.title}</h3>
            <p style={{ color: 'var(--system-secondary-label)', marginBottom: '20px' }}>
              {report.description}
            </p>
            
            <button 
              onClick={() => downloadReport(report.id)}
              disabled={loading}
              className="premium-button"
              style={{ 
                background: report.color,
                width: '100%'
              }}
            >
              {loading ? (
                <span className="loading-spinner" style={{ width: 20, height: 20 }} />
              ) : (
                'Download Excel'
              )}
            </button>
          </div>
        ))}
      </div>

      <style jsx>{`
        .report-card {
          transition: all 0.3s ease;
          animation: fadeIn 0.5s ease;
          animation-fill-mode: both;
        }

        .report-card:nth-child(1) { animation-delay: 0.1s; }
        .report-card:nth-child(2) { animation-delay: 0.2s; }
        .report-card:nth-child(3) { animation-delay: 0.3s; }
        .report-card:nth-child(4) { animation-delay: 0.4s; }
        .report-card:nth-child(5) { animation-delay: 0.5s; }

        .report-icon {
          width: 64px;
          height: 64px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .report-card:hover .report-icon {
          transform: scale(1.1) rotate(5deg);
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default Reports;